import React from "react";
import { useSelector } from 'react-redux';
import { floral } from '../language';

const QUOTES = ['one', 'two', 'three'];

function Testimonials(props) {
  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  return (
    <div className="lf-bg-white lf-section-anchor">
      <div className="lf-editorial py-5">
        <div className="lf-reveal" style={{ maxWidth: '36rem' }}>
          <p className="lf-eyebrow">{floral.testimonials.eyebrow[language]}</p>
          <h2 className="lf-section-heading" style={{ fontSize: '2.35rem', lineHeight: 1.22, letterSpacing: '-0.04em' }}>
            {floral.testimonials.title[language]}
          </h2>
        </div>
        <div className="row mt-4" style={{ borderTop: '1px solid var(--lf-line)', borderBottom: '1px solid var(--lf-line)' }}>
          {QUOTES.map((key, index) => {
            return (
              <div
                className="col-md-4 py-4 lf-reveal"
                key={key}
                style={{ borderRight: index < 2 ? '1px solid var(--lf-line)' : 'none' }}
              >
                <p className="lf-display" style={{ fontSize: '1.15rem', lineHeight: 1.55 }}>
                  &ldquo;{floral.testimonials[key].quote[language]}&rdquo;
                </p>
                <footer
                  className="mt-3"
                  style={{
                    fontSize: '0.72rem',
                    fontWeight: 700,
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--lf-sage-dark)',
                  }}
                >
                  {floral.testimonials[key].name[language]}
                </footer>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export { Testimonials };
